import { CancellationWindowType } from 'lib/graphql/generated';

export const getRefundableText = (cancellationType: CancellationWindowType) => {
  switch (cancellationType) {
    case 'FULLY_REFUNDABLE':
      return 'Full refund';
    case 'PARTIALLY_REFUNDABLE':
      return 'Partial refund';
    case 'NON_REFUNDABLE':
      return 'Non-refundable';
    default:
      return '';
  }
};
